/**
 *
 * @license
 *
 * */
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.scss';

export default function LicensePage() {
    // const [isLoading, setisLoading] = useState(false);
    usePreventDefault();
    useEffect(() => {}, []);

    return (
        <div className="license-page">
            <h1>{intl.get('commonLandingPage.foxitName')}</h1>
            <h2>
                {intl.get(
                    'commonLandingPage.ApplicationSoftwareEndUserLicenseAgreement'
                )}
            </h2>
            <p>
                {intl.get('commonLandingPage.commencementDate', {
                    year: 2022,
                    month: 6,
                    day: 16,
                })}
            </p>
            <div className="content-box">
                <strong>{intl.get('commonLandingPage.importantNote')}</strong>
                {intl.get(
                    'commonLandingPage.applicationSoftwareLicenseAgreement'
                )}
                <strong>
                    {intl.get(
                        'commonLandingPage.pleaseReadAgreementCarefullyAndUnderstandIt'
                    )}
                </strong>
                <p className="no-margin">
                    {intl.get('commonLandingPage.agreeThisAgreement')}
                </p>
            </div>

            <h3>{intl.get('commonLandingPage.rangeApplication')}</h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.firstAgreement')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondAgreement')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.thirdAgreement')}
            </p>
            <h3>{intl.get('commonLandingPage.licensesRestrictions')}</h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.firstRestrictions')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondRestrictions')}
            </p>
            <p className="text-indent">
                {intl.getHTML('commonLandingPage.thirdRestrictions')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.fourthRestrictions')}
            </p>
            <h3>{intl.get('commonLandingPage.obligationsWarranties')}</h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.firstWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.firstSubFirstWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.secondSubFirstWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.thirdSubFirstWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.fourthSubFirstWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.fifthSubFirstWarranties')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.firstSubSecondWarranties')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.secondSubSecondWarranties')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.thirdWarranties')}
            </p>
            <h3>{intl.get('commonLandingPage.limitationLiability')}</h3>
            <p className="text-indent">
                {intl.getHTML('commonLandingPage.firstLiability')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondLiability')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.thirdLiability')}
            </p>
            <h3>
                {intl.get('commonLandingPage.informationCollectionInteraction')}
            </h3>
            <p className="text-indent">
                {intl.getHTML('commonLandingPage.firstInteraction')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondInteraction')}
            </p>
            <h3>
                {intl.get('commonLandingPage.intellectualLicensingProtection')}
            </h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.firstProtection')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondProtection')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.thirdProtection')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.fourthProtection')}
            </p>
            <h3>{intl.get('commonLandingPage.infringementComplaint')}</h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.infringementComplaintTip')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.contactNumber')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.email')}
            </p>
            <h3>
                {intl.get(
                    'commonLandingPage.productChangeDiscontinuationService'
                )}
            </h3>
            <p className="text-indent board-text">
                {intl.getHTML('commonLandingPage.firstProductChange')}
            </p>
            <p className="text-indent">
                {intl.getHTML('commonLandingPage.secondProductChange')}
            </p>
            <h3>{intl.get('commonLandingPage.other')}</h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.firstOther')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.secondOther')}
            </p>
            <p className="text-indent">
                {intl.get('commonLandingPage.thirdOther')}
            </p>
            <p className="text-indent">
                {intl.getHTML('commonLandingPage.fourthOther')}
            </p>
            <h3>{intl.get('commonLandingPage.agreementUpdateObligation')}</h3>
            <p className="text-indent">
                {intl.getHTML('commonLandingPage.firstObligation')}
            </p>
            <h3>{intl.get('commonLandingPage.contactUs')}</h3>
            <p className="text-indent">
                {intl.get('commonLandingPage.pleaseContact')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.contactNumber')}
            </p>
            <p className="text-indent2">
                {intl.get('commonLandingPage.email')}
            </p>
        </div>
    );
}
